import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgGaruda from '../../../assets/images/pngwing.png';
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf';
import { useCallback, useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import { formatDateStringLocalDate } from "../../../utilities/Utils";
import Kemasan from "../../../utilities/Kemasan";
import PropinsiEn from "../../../utilities/PropinsiEn";
import imgCheckBox from "../../../assets/images/icons/checkbox_blank_outline_icon.png"
import imgCheckBoxIcon from "../../../assets/images/icons/checkbox_icon.png"

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingRow: {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingEn: {
        fontSize: 9,
        textAlign: "center",
    },
    headingIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 9,
        textAlign: "center",
        marginBottom: 3
    },
    textRefNo: {
        fontSize: 7,
        textAlign: "right"
    },
    texthal2: {
        fontSize: 9,
        textAlign: "right"
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableIdt: {
        borderLeftWidth: 1,
        borderBottom: 1,
        display: 'table',
        width: 'auto',
    },
    tableIdt2: {
        borderBottom: 1,
        display: 'table',
        width: 'auto',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableCol: {
        width: '100%',
        padding: 3,
        textAlign: 'left',
    },
    tableCol1: {
        width: '50%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol2: {
        width: '50%',
        padding: 5,
        textAlign: 'left',
    },
    tableColIdt1: {
        width: '50%',
        padding: 3,
        textAlign: 'left',
    },
    tableColIdt2: {
        width: '50%',
        padding: 3,
        textAlign: 'left',
    },
    text: {
        fontSize: 7,
        textAlign: "center",
        fontWeight: "bold",
    },
    italicText: {
        fontFamily: "Roboto-Italic",
        fontSize: 7,
        textAlign: "center",
    },
    textEn: {
        fontSize: 8,
        textAlign: "left",
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "left",
    },
    textEn7: {
        fontSize: '4.4',
        textAlign: "left",
    },
    textIn7: {
        fontFamily: "Roboto-Italic",
        fontSize: '4.4',
        textAlign: "left",
    },
    textBox: {
        fontSize: 9
    },
    squareStyle: {
        width: '10px',
        height: '10px',
        border: 1,
        borderColor: '#000000',
    },
    checkicon: {
        width: 12,
        height: 12
    }
})

const DraftXF = ({ dataDisposisi, datappm }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataHc, setDataHc] = useState(null)
    const [upt, setUpt] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    const [ppmMutuArea, setPpmMutuArea] = useState(null)
    const [ppmKemasan, setPpmKemasan] = useState([])
    const [totalJumlah, setTotalJumlah] = useState([])

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const jsonMutuPK = {
                nomorAju: datappm.nomorAju,
                noProses: dataDisposisi.noTugas
            };

            const jsonPelMuat = {
                jnsPelabuhan: "D",
                kodePelabuhan: datappm.pelabuhanMuat
            };

            const jsonPelBongkar = {
                jnsPelabuhan: "L",
                kodePelabuhan: datappm.pelabuhanBongkar
            };

            const results = await Promise.allSettled([
                transaksiService.getHcMutuById(jsonMutuPK),
                userService.getUptById(datappm.kdUpt),
                masterService.getNegaraById(datappm.negaraPartner),
                masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
                masterService.getPelabuhanById(JSON.stringify(jsonPelBongkar)),
                transaksiService.listPpmDetilAll(datappm.nomorAju),
                transaksiService.getTotalJumlahKomoditiPerSatuan(datappm.nomorAju),
                transaksiService.listPpmKemasanAll(datappm.nomorAju),
                transaksiService.listPpmContainerAll(datappm.nomorAju),
                transaksiService.getPpmMutuById(datappm.nomorAju),
                transaksiService.listPpmMutuAreaAll(datappm.nomorAju)
            ])

            const [
                resHc,
                resUpt,
                resNeg,
                resPelMuat,
                resPelBongkar,
                resDetil,
                resTotal,
                resKemasanAll,
                resKontainer,
                resMutu,
                resMutuArea
            ] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            // Update state (batched oleh React)
            setDataHc(getData(resHc));
            setUpt(getData(resUpt, {}));
            setNegaraTujuan(getData(resNeg, {}))
            setPelMuat(getData(resPelMuat, {}));
            setPelBongkar(getData(resPelBongkar, {}));
            setPpmDetil(getData(resDetil));
            setTotalJumlah(getData(resTotal));
            setPpmKemasan(getData(resKemasanAll));
            setPpmKontainer(getData(resKontainer));
            setPpmMutu(getData(resMutu, {}));
            setPpmMutuArea(getData(resMutuArea))

        } catch (error) {
            console.error("Gagal memuat data:", error);
        }

    }, [datappm, dataDisposisi, transaksiService, masterService, userService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    return (
        <Document>
            <Page size="LEGAL" style={styles.page} wrap={false}>
                <View>
                    <Image style={styles.headingImg} src={imgGaruda} />
                    <Text style={styles.headingEn}>THE REPUBLIC OF INDONESIA</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>MINISTRY OF MARINE AFFAIRS AND FISHERIES</Text>
                </View>
                <View style={styles.headingRow}>
                    <Text style={[styles.headingEn, { paddingTop: "5" }]}>GEZONDHEIDSCERTIFICAAT / </Text>
                    <Text style={[styles.headingIn, { paddingTop: "5" }]}>SERTIFIKAT KESEHATAN</Text>
                </View>
                <View style={[styles.headingRow, { paddingTop: "5" }]}>
                    <Text style={[styles.headingEn, { marginLeft: 50, marginRight: 50 }]}>GEZONDHEIDSCERTIFICAAT VOOR DE INVOER VAN VOOR MENSELIJKE CONSUMPTIE BESTEMDE VISSERIJPRODUCTEN  / </Text>
                    <Text style={styles.headingIn}>UNTUK IMPOR PRODUK PERIKANAN YANG DIGUNAKAN UNTUK KONSUMSI MANUSIA</Text>
                </View>
                <View>
                    <Text style={styles.textRefNo}>Veterinair certificaat voor de invoer in de EU / Sertifikat Kesehatan ke UE</Text>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1, borderTop: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.1. Verzender / </Text>
                                <Text style={styles.textIn}>Pengirim :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>Naam / </Text>
                                <Text style={[styles.textIn, { paddingLeft: 5 }]}>Nama :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.nmPengirim : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>Adres / </Text>
                                <Text style={styles.textIn}>Alamat :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.alPengirim : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>Tel. / </Text>
                                <Text style={styles.textIn}>No Telp :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.telpPengirim : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderBottom: 0, borderTop: 1, borderRight: 1, paddingLeft: 3 }]}>
                            <View style={[styles.tableRow]}>
                                <Text style={styles.textEn}>I.2. Referentienummer certificaat / </Text>
                                <Text style={styles.textIn}>Nomor Sertifikat: </Text>
                            </View>
                            <View style={[styles.tableRow, { borderBottom: 1 }]}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                            </View>
                            <View style={[styles.tableCol, { paddingLeft: 3 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.3. Bevoegde centrale autoriteit / </Text>
                                    <Text style={styles.textIn}>Otoritas Kompeten Pusat: </Text>
                                </View>
                                <View style={[styles.tableCol, { borderBottom: 1 }]}>
                                    <Text style={styles.textEn}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderBottom: 0, paddingLeft: 3 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.4. Bevoegde lokale autoriteit / </Text>
                                    <Text style={styles.textIn}>Otoritas Kompeten Daerah: </Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>{upt !== null ? upt.nmInggris : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.5. Geadresseerde/</Text>
                                <Text style={styles.textIn}>Penerima Borang :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>Naam / </Text>
                                <Text style={[styles.textIn, { paddingLeft: 5 }]}>Nama :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.nmPenerima : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>Adres / </Text>
                                <Text style={styles.textIn}>Alamat :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.alPenerima : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>Postcode / </Text>
                                <Text style={styles.textIn}>Kode Pos :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.kdposPenerima : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>Tel. / </Text>
                                <Text style={styles.textIn}>No Telp :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.telpPenerima : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.6. </Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>I.7. Land van oorsprong / </Text>
                            <Text style={styles.italicText}>Negara Asal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>ISO-Code/</Text>
                            <Text style={styles.italicText}>Kode ISO</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>I.8. Regio van oorsprong / </Text>
                            <Text style={styles.italicText}>Wilayah Asal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>Code / </Text>
                            <Text style={styles.italicText}>Kode</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>I.9. Land van bestemming</Text>
                            <Text style={styles.italicText}>Negara Tujuan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>ISO-Code</Text>
                            <Text style={styles.italicText}>Kode ISO</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>I.10.</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderBottomWidth: 1 }]}>
                    <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1, borderLeftWidth: 1 }]}>
                        <Text style={styles.text}>INDONESIA</Text>
                    </View>
                    <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                        <Text style={[styles.text]}>ID</Text>
                    </View>
                    <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                        <Text style={[styles.text]}>{upt !== null ? <PropinsiEn id={upt.kdProp} /> : '-'}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                        <Text style={[styles.text]}>{upt !== null ? upt.kdProp : '-'}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                        <Text style={[styles.text]}>{negaraTujuan !== null ? negaraTujuan.uraianNegara : '-'}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                        <Text style={[styles.text]}>{datappm !== null ? datappm.negaraPartner : '-'}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                        <Text style={[styles.text]}>-</Text>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={[styles.tableRow, { borderRightWidth: 1 }]}>
                        <View style={[styles.tableColIdt1, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.11. Plaats van oorsprong / </Text>
                                <Text style={styles.textIn}>Tempat Asal </Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Name / </Text>
                                <Text style={styles.textIn}>Nama :</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Adres / </Text>
                                <Text style={styles.textIn}>Alamat :</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.alUpi : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Erkenningsnummer / </Text>
                                <Text style={styles.textIn}>Nomor Approval</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>{ppmMutu !== null ? ppmMutu.upiNoRegUe : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableColIdt]}>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 3 }]}>I.12.</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.13. Plaats van lading / </Text>
                                <Text style={styles.textIn}>Tempat Muat :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{pelMuat !== null ? pelMuat.uraianPelabuhan : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.14. Datum van vertrek / </Text>
                                <Text style={styles.textIn}>Tanggal Berangkat :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglBerangkat) : ''}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.15. Vervoermiddelen</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>Vliegtuig/</Text>
                                    <Text style={styles.textIn}>Pesawat Terbang</Text>
                                    {
                                        datappm !== null && datappm.moda === '3' ?
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                            <Image src={imgCheckBox} style={styles.checkicon} />
                                    }
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>Vaartuig/</Text>
                                    <Text style={styles.textIn}>Kapal Laut</Text>
                                    {
                                        datappm !== null && datappm.moda === '1' ?
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                            <Image src={imgCheckBox} style={styles.checkicon} />
                                    }
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>Treinwagon/</Text>
                                    <Text style={styles.textIn}>Kereta Api Barang</Text>
                                    <Image src={imgCheckBox} style={styles.checkicon} />
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>Wegvoertuig/</Text>
                                    <Text style={styles.textIn}>Angkutan Umum</Text>
                                    <Image src={imgCheckBox} style={styles.checkicon} />
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>Andere/</Text>
                                    <Text style={styles.textIn}>Lainnya</Text>
                                    <Image src={imgCheckBox} style={styles.checkicon} />
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Identificatie / </Text>
                                <Text style={styles.textIn}>Identifikasi</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.nmTrans : ''} / {dataHc !== null ? dataHc.noFlight : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Referentiedocumenten / </Text>
                                <Text style={styles.textIn}>Referensi dokumen</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={[styles.tableCol, { borderBottom: 0, borderTop: 0, borderRight: 0, paddingLeft: 3 }]}>
                                <Text style={styles.textEn}>I.16. Grensinspectiepost van binnenkomst in EU / </Text>
                                <Text style={[styles.textIn, { paddingLeft: 5 }]}>Pelabuhan Tujuan di UE </Text>
                            </View>
                            <View style={[styles.tableRow, { borderBottom: 1 }]}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{pelBongkar !== null ? pelBongkar.uraianPelabuhan : ''}</Text>
                            </View>
                            <View style={[styles.tableCol, { paddingLeft: 3 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.17.</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.18. Omschrijving van de goederen</Text>
                                <Text style={styles.textIn}>Deskripsi Produk</Text>
                            </View>
                            <View style={[styles.tableRow]}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{ppmMutu !== null ? ppmMutu.mutuDesk : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={[styles.tableCol, { borderBottom: 0, borderTop: 0, borderRight: 0, paddingLeft: 3 }]}>
                                <Text style={styles.textEn}>I.19. Productcode (GS-code) / </Text>
                                <Text style={[styles.textIn, { paddingLeft: 5 }]}>Kode HS Produk</Text>
                            </View>
                            <View style={[styles.tableRow, { borderBottom: 1 }]}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>
                                    {
                                        ppmDetil.map((detil, index) => {
                                            return <>{detil.kodeHs}</>
                                        })
                                    }
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { paddingLeft: 3 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.20. Hoeveelheid/</Text>
                                    <Text style={[styles.textIn, { paddingLeft: 5 }]}>Jumlah</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>
                                        {
                                            totalJumlah.map((detil, index) => {
                                                return (
                                                    detil.kodeSatuan.toUpperCase() === 'KGM' ?
                                                        detil.totalJumlah + ' ' + detil.kodeSatuan.toUpperCase() :
                                                        detil.totalJumlah + ' ' + detil.kodeSatuan.toUpperCase() + ' = ' + detil.totalNetto + ' KGM'
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.21. Temperatuur producten / </Text>
                                <Text style={styles.textIn}>Temperatur produk</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>Omgevingstemperatuur / </Text>
                                    <Text style={styles.textIn}>Ruang</Text>
                                    {/* <View style={styles.squareStyle}></View> */}
                                    {
                                        ppmMutu !== null && ppmMutu.mutuTempTipe === '1' ?
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                            <Image src={imgCheckBox} style={styles.checkicon} />
                                    }
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>Gekoeld / </Text>
                                    <Text style={styles.textIn}>Beku</Text>
                                    {/* <View style={styles.squareStyle}></View> */}
                                    {
                                        ppmMutu !== null && ppmMutu.mutuTempTipe === '3' ?
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                            <Image src={imgCheckBox} style={styles.checkicon} />
                                    }
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>Bevroren / </Text>
                                    <Text style={styles.textIn}>Dingin</Text>
                                    {/* <View style={styles.squareStyle}></View> */}
                                    {
                                        ppmMutu !== null && ppmMutu.mutuTempTipe === '2' ?
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                            <Image src={imgCheckBox} style={styles.checkicon} />
                                    }
                                </View>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.22. Aantal verpakkingen / </Text>
                                <Text style={styles.textIn}>Jumlah Kemasan :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>
                                    {
                                        ppmKemasan !== null && ppmKemasan.map((kms, idx) => {
                                            return (
                                                <>{kms.jumlah} <Kemasan id={kms.kodeKemasan} />{idx < ppmKemasan.length - 1 ? '; ' : ''}</>
                                            )
                                        })
                                    }
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.23. Nr. zegel en nr. container / </Text>
                                <Text style={styles.textIn}>No. Segel / Kontainer</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.textEn}>
                                    {
                                        ppmKontainer !== undefined && ppmKontainer !== null &&
                                        ppmKontainer.map((kont, index) => {
                                            return (
                                                <>
                                                    {kont.nomor} / {kont.nomorSegel} {index < ppmKontainer.length - 1 ? ';' : ''}
                                                </>
                                            )
                                        })
                                    }
                                </Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.24. Aard van de verpakking / </Text>
                                <Text style={styles.textIn}>Jenis Kemasan</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>
                                    {
                                        ppmKemasan !== null && ppmKemasan.map((kms, idx) => {
                                            return (
                                                <><Kemasan id={kms.kodeKemasan} />{idx < ppmKemasan.length - 1 ? '; ' : ''}</>
                                            )
                                        })
                                    }
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.25. Goederen gecertificeerd voor/ </Text>
                                <Text style={styles.textIn}>Komoditas yang disertifikasi untuk: </Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Menselijke consumptie / </Text>
                                <Text style={styles.textIn}>Konsumsi manusia </Text>
                                {
                                    datappm !== null && datappm.peruntukan === '1' ?
                                        <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                        <Image src={imgCheckBox} style={styles.checkicon} />
                                }
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.26.</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.27. Voor invoer of toelating in EU / </Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 5 }]}>
                                <Text style={styles.textIn}>Untuk impor atau ijin masuk ke UE </Text>
                                {
                                    ppmMutu !== null && ppmMutu.upiNoRegUe !== null ?
                                        <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                        <Image src={imgCheckBox} style={styles.checkicon} />
                                }
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableIdt, { borderBottom: 0 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1, borderBottom: 0 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>I.25. Identificatie van de goederen / </Text>
                                <Text style={styles.textIn}>Identifikasi komoditas</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableIdt, { borderBottom: 0 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 0 }]}>
                            <Text style={styles.text}>Soort (Wetenschappelijke benaming) / </Text>
                            <Text style={styles.italicText}>Spesies (nama latin)</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 0 }]}>
                            <Text style={styles.text}>Aard van de goederen /</Text>
                            <Text style={styles.italicText}>Asal produk</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 0 }]}>
                            <Text style={styles.text}>Soort behandeling / </Text>
                            <Text style={styles.italicText}>Jenis perlakuan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 0 }]}>
                            <Text style={styles.text}>Erkenningsnummer van de inrichtingen Verwerkingsbedrijf / </Text>
                            <Text style={styles.italicText}>Nomor Approval Pabrik Pengolahan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 0 }]}>
                            <Text style={styles.text}>Aantal verpakkingen</Text>
                            <Text style={styles.italicText}>Jumlah Kemasan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>Nettogewicth</Text>
                            <Text style={styles.italicText}>Berat bersih</Text>
                        </View>
                    </View>
                </View>
                {
                    ppmDetil.map((detil, index) => {
                        return (
                            <>
                                <View key={index} style={[styles.tableRow, { borderBottomWidth: 1, borderTop: 0 }]}>
                                    <View style={[styles.tableCol, { width: "20%", borderRightWidth: 0, borderLeftWidth: 1 }]}>
                                        <Text style={[styles.text]}>{detil.namaLatin}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "19%", borderRightWidth: 0 }]}>
                                        <Text style={[styles.text]}>
                                            {
                                                ppmMutuArea !== null && ppmMutuArea !== undefined && ppmMutuArea[0].mutuArea === '1' ?
                                                    'Farm' : 'Wild'
                                            }
                                        </Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "19%", borderRightWidth: 0 }]}>
                                        <Text style={[styles.text]}> - </Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "23%", borderRightWidth: 0 }]}>
                                        <Text style={[styles.text]}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                                        <Text style={[styles.text]}>{dataHc !== null ? dataHc.noRegUpi : ''}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "20%", borderRightWidth: 0 }]}>
                                        <Text style={[styles.text]}>
                                            {
                                                ppmKemasan !== null && ppmKemasan.map((kms, idx) => {
                                                    return (
                                                        <>{kms.jumlah} <Kemasan id={kms.kodeKemasan} />;</>
                                                    )
                                                })
                                            }
                                        </Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                        <Text style={[styles.text]}>{detil.jumlah} {detil.kodeSatuan}</Text>
                                    </View>
                                </View>
                            </>
                        )
                    })
                }
            </Page>
            <Page size="LEGAL" style={styles.page} wrap={false}>
                <View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={[styles.texthal2, { textAlign: "left" }]}>LAND/NEGARA : INDONESIA</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={[styles.texthal2, { textAlign: "right" }]}>Visserijproducten/ Produk perikanan</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableIdt, { borderTop: 1 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "50%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { textAlign: "left" }]}>II. Informatie over de Gezondheid/</Text>
                            <Text style={[styles.italicText, { paddingLeft: 13, textAlign: "left" }]}>Informasi Kesehatan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "31%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { textAlign: "left" }]}>II.a. Referentienummer certificaat / </Text>
                            <Text style={[styles.italicText, { paddingLeft: 13, textAlign: "left" }]}>Nomor Sertifikat</Text>
                            <View style={[styles.tableRow, { borderBottom: 0 }]}>
                                <Text style={[styles.text, { paddingLeft: 13, textAlign: "left" }]}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { textAlign: "left" }]}>II.b. </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableIdt, { borderRightWidth: 1 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableRow, { width: "3%" }]}>
                            <Text style={styles.textEn7}>II.1.</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={styles.textEn7}>(1) Verklaring inzake de volksgezondheid/</Text>
                            <Text style={styles.textIn7}>(1) Pernyataan kesehatan umum</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { paddingLeft: 10 }]}>
                            <Text style={styles.textEn7}>Ondergetekende verklaart dat hij kennis heeft van de relevante bepalingen van de Verordeningen (EG) nr. 178/2002, (EG) nr. 852/2004, (EG) nr. 853/2004 en (EG) nr. 854/2004 en dat de hierboven beschreven visserijproducten overeenkomstig die voorschriften zijn geproduceerd en met name dat/ </Text>
                            <Text style={styles.textIn7}>Saya yang bertanda tangan di bawah ini menyatakan bahwa saya menyadari sepenuhnya keterkaitan dari ketetapan peraturan peraturan (KE) No. 178/2002. (KE) No. 852/2004, (KE) No. 853/2004 dan (KE) No.854/2004 dan menyatakan dengan sebenarnya bahwa produk perikanan yang dijelaskan di atas diproduksi sesuai dengan peraturan-peraturan tersebut, khususnya bahwa produk tersebut:</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>zij afkomstig zijn van een bedrijf dat (bedrijven die) overeenkomstig Verordening (EG) nr. 852/2004 een op de HACCP-beginselen gebaseerd programma toepast (toepassen);</Text>
                            <Text style={styles.textIn7}>/berasal dari unit pengolahan ikan yang menerapkan program berdasarkan prinsip-prinsip HACCP sexuai dengan Peraturan (KE) No. 852/2004, </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>zij zijn gevangen en aan boord van de vaartuigen zijn behandeld, op hygiënische wijze zijn gelost, behandeld en, in voorkomend geval, bewerkt, verwerkt, ingevroren en ontdooid overeenkomstig de voorschriften van sectie VIII, hoofdstukken I tot en met IV, van bijlage III bij Verordening (EG) nr. 853/2004</Text>
                            <Text style={styles.textIn7}>/telah ditangkap dan ditangani di atas kapal perikanan, didaratkan, ditangani dan dipersiapkan, diolah, dibekukan dan dilelehkan secara higienis sesuai dengan persyaratan pada sekti VIII Rab I sampai dengan IV Lampiran III Peraturan (KE) No.853/2004 </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>zij voldoen aan de gezendheidsnormen van sectie VIII, hoofdstuk V, van bijlage III bij Verordening (EG) nr. 853/2004 en de criteria van Verordening (EG) nr. 2073/2005 inzake microbiologische criteria voor levensmiddelen:</Text>
                            <Text style={styles.textIn7}>/ Lampiran III Peraturan (KE) No 853/2004 dan kriteria yang tertulis dalam Peraturan (KE) No 2073/2005 tentang kriteria mikrobiologikal untuk bahan pangan, </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>zij zijn verpakt, opgeslagen en vervoerd overeenkomstig sectie VIII, hoofdstukken VI, VII en VIII, van bijlage III bij Verordening (EG) nr. 853/2004</Text>
                            <Text style={styles.textIn7}>/telah dikemas, disimpan dan diangkut sesuai dengan Seksi VIII. Bab 17, Bab VII dan VIII Lampiran Peraturan (KE) No. 853/2004 </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>zij voorzien zijn van een merk overeenkomstig sectie I van bijlage Il bij Verordening (EG) nr. 853/2004</Text>
                            <Text style={styles.textIn7}>/telah ditandai sesuai dengan seksi I Lampiran II peraturan (KE) No.854/2004,  </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>met betrekking tot levende dieren en producten daarvan, indien afkomstig van aquacultuur, alle garanties worden geboden die zijn vervat in de overeenkomstig Richtlijn 96/23/EG, en met name artikel 29, ingediende plannen betreffende residuen, en</Text>
                            <Text style={styles.textIn7}>jaminan ini mencakup hewan dan produk hidup, jika berasal asli dari pembudidayaan, harus dilengkapi dengan rencana monitoring residu sesuai dengan Direktif 96/23/EC, dan khususnya Pasal 29, dan</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>zij op afdoende wijze de officiële controles overeenkomstig bijlage III by Verordening (EG) nr. 854/2004 hebben ondergaan</Text>
                            <Text style={styles.textIn7}>telah dilakukan pengendalian dengan memuaskan sebagaimana Lampiran III Peraturan (KE) No. 854/2004</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>II.2. (2)(4)Verklaring inzake de diergezondheid voor vis en schaaldieren afkomstig van aquacultuur</Text>
                            <Text style={[styles.textIn7, { paddingLeft: 12 }]}>(2)(4) Pernyataan kesehatan hewan untuk ikan dan krustasea yang dibudidayakan</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>II.2.1. (3)(4)[Voorschriften voor voorten die vatbaar zijn voor epizoötische hematopoëtische necrose (EHN), taura-syndroom en de yellow-head-ziekte</Text>
                            <Text style={[styles.textIn7, { paddingLeft: 14 }]}>(3)(4)Persyaratan untuk jenis-jenis yang rentan terhadap penyakit Epizootic haematopoletic necrosis (EHN), Taura syndrome dan yellowhead.</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 14 }]}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>Ondergetekende, officieel inspecteur, verklaart dat de in deel I van dit certificaat bedoelde aquacultuurdieren of producten daarvan: (5)afkomstig zijn uit een land/grondgebied, gebied of compartiment dat overeenkomstig hoofdstuk VII van Richtlijn 2006/88/EG of de desbetreffende OIE-norm vrij verklaard is van (4)(EHN) (4) (taura-syndroom ] (4) [yellow-head-ziekte] door de bevoegde autoriteit van zijn land, </Text>
                            <Text style={styles.textIn7}>Saya, inspektur mutu yang bertanda tangan dibawah ini, menyatakan bahwa produk budidaya sebagaimana disebutkan pada Bagian I sertifikat ini berasal dari negara/territorial, zona atau kompartemen yang telah dinyatakan bebas dari (4)EHN, (4) Taura syndrome (4) Yellowhead sesuai dengan Bab VII Directive 2006/88/EC ataw Standard OIE yang sesuai oleh Otoritas Kompeten di Indonesia,</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>i) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>waar van de desbetreffende ziekten bij de bevoegde autoriteit aangifte moet worden gedaan en meldingen van vermoede infecties met de desbetreffende ziekte onmiddellijk door de bevoegde autoriteit moeten worden onderzocht,</Text>
                            <Text style={styles.textIn7}>Apabila penyakit-penyakit tersebut tendeteksi oleh Otoritas Kompeten dan adanya laporan tentang kecurigaan infeksi oleh penyakit yang relevan harus segera diinvestigasi oleh otoritas kompeten</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>ii) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>alle binnengebrachte soorten die vatbaar zijn voor de desbetreffende ziekten afkomstig zijn van een gebied dat vrij verklaard is van de desbetreffende ziekte, en</Text>
                            <Text style={styles.textIn7}>Seluruh pengenalan jenis yang rentan terhadap penyakit-penyakit tersebut diatas berasal darı area yang telah dinyatakan bebas dari penyakit, dan</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>iii) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>de voor de desbetreffende ziekten vathare soorten niet tegen de desbetreffende ziekten zijn gevaccineerd </Text>
                            <Text style={styles.textIn7}>jenis yang rentan terhadap penyakit-penyakit tersebut diatas tidak divaksinasi dengan vaksin penyakit-penyakit tersebut. </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>II.2.2. </Text>
                                <Text style={[styles.textEn7, { width: '97%' }]}>(3)(4)[Voorschriften voor soorten die vatbaar zijn voor virale hemorragische septikemie (VHS), infectieuze hematopoëtische necrose (IHN), infectieuze zalmanemie (ISA), koi- herpesvirus (KHV) en besmetting met het wittevlekkenvirus, en die bestemd zijn voor lidstaat, gebied of compartiment die/dat ziektevrij is verklaard of waarvoor een surveillance- of uitroeiingsprogramma voor de desbetreffende ziekte geldt</Text>
                            </View>
                            <Text style={[styles.textIn7, { paddingLeft: 16 }]}>(3)(4) Persyaratan untuk jenis-jenis yang rentan terhadap penyakit Viral haemorrhagic septicaemia (VHS), Infectious haematopoletic necrosis (IHN), Infectious salmon anaemia (ISA), Koj herves virus (KHV), dan bintik putih (white spot) untuk tujuan ekspor ke negara anggota UE, zona atau kompartemen yang telah dinyatakan bebas penyakit atau telah disurvailen atau telah melalui program pemberantasan penyakit-penyakit yang relevan.</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 14 }]}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>Ondergetekende, officieel inspecteur, verklaart dat de in deel I van dit certificaat bedoelde aquacultuurdieren:(5)afkomstig zijn uit een land grondgebied, gebied of compartiment dat overeenkomstig hoofdstuk VII van Richtlijn 2006/88/EG of de desbetreffende OIE-norm vrij verklaard is van (4)[VHS] (4) [IHN] (4) [ISA] (4) [KHV] (4) [besmetting met het wittevlekkenvirus door de bevoegde autoriteit van zijn land,</Text>
                            <Text style={styles.textIn7}>Saya Inspektur mutu yang bertanda tangan dibawah ini menyatakan bahwa hewan/produk budidaya sebagaimana disebutkan pada bagian I sertifikat ini, ()Berasal dari negara territorial, zona atau kompartemen yang telah dinyatakan bebas dari penyakit (VHS (4)IHN, (4)ISA, (4)KHV (bintik putih (white spot) sesuai dengan Bab VII Directive 2006/88/EC atau Standard OIE yang sesuai oleh Otoritas Kompeten di Indonesia</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>i) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>waar van de desbetreffende ziekten bij de bevoegde autoriteit aangifte moet worden gedaan en meldingen van vermoede infecties met de desbetreffende ziekte onmiddellijk door de bevoegde autoriteit moeten worden onderzocht,</Text>
                            <Text style={styles.textIn7}>Apabila penyakit-penyakit tersebut tendeteksi oleh Otoritas Kompeten dan adanya laporan tentang kecurigaan infeksi oleh penyakit yang relevan harus segera diinvestigasi oleh otoritas kompeten</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>ii) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>alle binnengebrachte soorten die vatbaar zijn voor de desbetreffende ziekten afkomstig zijn uit een gebied dat vrij van de ziekte is verklaard, en</Text>
                            <Text style={styles.textIn7}>seluruh pengenalan jenis yang rentan terhadap penyakit-penyakit tersebut diatas berasal dari area yang telah dinyatakan bebas dari penyakit, dan</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>iii) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>de voor de desbetreffende ziekten vathare soorten niet tegen de desbetreffende ziekten zijn gevaccineerd </Text>
                            <Text style={styles.textIn7}>jenis yang rentan terhadap penyakit-penyakit tersebut diatas tidak divaksinasi dengan vaksin penyakit-penyakit tersebut. </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>II.2.3. Vervoers-enetiketteringsvoorschriften </Text>
                            <Text style={[styles.textIn7, { paddingLeft: 14 }]}>Persyaratan Transportasi dan pelabelan </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 14 }]}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>Ondergetekende, officieel inspecteur, verklaart dat</Text>
                            <Text style={styles.textIn7}>Saya, inspektur mutu dibawah ini menyatakan bahwa</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>II.2.3.1</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { paddingLeft: 13 }]}>
                            <Text style={styles.textEn7}>de hierboven bedoelde aquacultuurdieren worden gehouden onder omstandigheden, inclusief waterkwaliteit, die geen gevolgen hebben voor hun gezondheidsstatus</Text>
                            <Text style={styles.textIn7}>/hewan budidaya sebagaimana tersebut diatas ditempatkan pada kondisi, termasuk mutu air, yang tidak mempengaruhi status kesehatannya </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>II.2.3.2</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { paddingLeft: 13 }]}>
                            <Text style={styles.textEn7}>de vervoerscontainer of het schip met leeftank vóór het laden schoon en ontsmet of niet eerder gebruikt is, en</Text>
                            <Text style={styles.textIn7}>/ wadah transportasi atau palka pada perahu sebelum dimasukkan dalam keadaan bersih dan disveihamakan atau sebelumnya tidak digunakan, dan</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>II.2.3.3</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { paddingLeft: 13 }]}>
                            <Text style={styles.textEn7}>de rending voorzien is van een leesbaar etiket aan de buitenkant van de container of, wanneer vervoerd met een schip met leeftank, op het scheepsmanifest, met de relevante informatie, als bedoeld in de vakken 1,7 tot en met 1,11 van deel 1 van dit certificaat, en de volgende vermelding</Text>
                            <Text style={styles.textIn7}>/partai produk vang dikirim diidentifikasi dengan label yang dapat dibaca pada bagian luar wadah, atau pada saat transportasi dengan perahu, pada manifestasi kapal, dengan informasi yang relevan sesuai dalam kotak no 17 sampai 1.11 pada sertifikat ini dan pernyataan berikut </Text>
                        </View>
                    </View>
                    <View style={styles.tableCol}>
                        <View style={[styles.tableRow, { paddingLeft: 27 }]}>
                            <Text style={styles.textEn7}>"(4)[Vis](4)[Schaaldieren bestemd voor menselijke consumptie in deUnie"./ </Text>
                            <Text style={styles.textIn7}>"(4) Ikan dan (4) Krustasea untuk tujuan konsumsi manusia di Negara Uni Eropa</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 3 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>Opmerkingen</Text>
                                <Text style={styles.textIn7}>/Catatan</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>Deel I</Text>
                                <Text style={styles.textIn7}>/Bagian I</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Vak I.8</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 30 }]}>:</Text>
                                <Text style={styles.textEn7}>Regio van oorsprong: voor diepgevroren of verwerkte tweekleppige weekdieren: geef het productiegebied aan.</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.8 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 5 }]}>: </Text>
                                <Text style={styles.textEn7}>Wilayah asal. Untuk kekerangan beku atau vang diolah, disebutkan daerah produksinya.</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Vak I.11</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 30 }]}>:</Text>
                                <Text style={styles.textEn7}>Plaats van oorsprong: naam en adres van de inrichting van verzending.</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.11 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 5 }]}>: </Text>
                                <Text style={styles.textEn7}>Tempat Asal : Nama dan alamat UPI.</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Vak I.15</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 30 }]}>: </Text>
                                <Text style={styles.textEn7}>Registratienummer (voor wagons, containers en vrachtwagens), vluchtnuminer (vliegtuig) of naam van het schip In geval van overslag moet afzonderlijke informatie worden verstrekt</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.15 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 5 }]}>: </Text>
                                <Text style={styles.textEn7}>Nomor registrasi (kereta barang atau kontainer dan lori), nomor penerbangan (pesawat) atau nama (kapal). Dibuat keterangan yang terpisah pada saat pembongkaran dan pemuatan kembali</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Vak I.19 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 30 }]}>: </Text>
                                <Text style={[styles.textEn7, { width: '80%' }]}>Gebruik de juiste code van het Geharmoniseerd Systeem(GS) van de Werelddouaneorganisatie van de volgende rubrieken: 03.01, 03.02, 03.03, 03.04, 03.05, 03.06, 03.07, 03.08, 05.11, 15.04, 15.16, 15.18, 16.03, 16.04, 16.05 atau 21.06 </Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.19 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 5 }]}>: </Text>
                                <Text style={[styles.textEn7, { width: '80%' }]}>Menggunakan Kode Harmonized System (HS)" yang sesuai dengan Organizası Bea Cukai Dunia untuk judul-judul sebagai berikut: 03.01, 03.02, 03.03, 03.04, 03.05, 03.06, 03.07, 03.08, 05.11, 15.04, 15.16, 15.18, 16.03, 16.04, 16.05 atau 21.06</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Vak I.23</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 30 }]}>:</Text>
                                <Text style={styles.textEn7}>Identificatie van container/zegelnummer: vermeld eventueel het volgnummer van het zegel Identifikasi </Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.23</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 2 }]}>:</Text>
                                <Text style={styles.textEn7}>Kontainer No Segel apabila terdapat no seri segel, maka harus dicantumkan </Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Vak I.28 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 30 }]}>: </Text>
                                <Text style={[styles.textEn7, { width: '80%' }]}>Aard van de goederen vermeld de oorsprong van het product aquacultuur of wild. Soort behandeling geef aan levend, gekoeld, diepgevroren of verwerkt, Verwerkingsbedrijf omvat fabticksvaartuig, vriesschip, koelhuls, verwerkingsfabriek.</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.28 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 5 }]}>: </Text>
                                <Text style={[styles.textEn7, { width: '80%' }]}>Asal produk jelaskan apakah hasil budidaya atau hasil tangkap Jenis perlakuan hidup, didinginkan, dibekukan atau diolah. Pabrik pengolahan meliputi kapal pengolah, kapal pembeku, gudang penyimpanan beku dan pabrik pengolahan </Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 3 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>Deel II</Text>
                                <Text style={styles.textIn7}>/Bagian II</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableCol, { paddingLeft: 5 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(1)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>Deel II.1 van dit certificaat is niet van toepassing op landen met speciale certificeringsvoorschriften in verband met de volksgezondheid, als vastgesteld in gelijkwaardigheidsovereenkomsten of andere wetgeving van de Unie.</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 8 }]}>Bagian II.1 dari sertifikat ini tidak berlaku bagi negara-negara dengan persyaratan sertifikasi kesehatan publik khusus seperti tertuang dalam perjanjian ekivalensi atau legislasi UE lainnya.</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(2)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>Deel II.2 van dit certificaat is niet van toepassing op/</Text>
                                <Text style={[styles.textIn7]}>Bagian II.2 dari sertifikat ini tidak berlaku bagi:</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8 }]}>
                                <Text style={styles.textEn7}>a)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>niet-levensvatbare schaaldieren, dat betekent schaaldieren die niet meer in staat zijn als levende dieren te overleven, als zij worden teruggezet in het milieu waaruit zij afkomstig zijn,</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 10 }]}>krustasea yang tidak dapat hidup lagi apabila dikembalikan ke lingkungan dimana mereka hidup.</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8 }]}>
                                <Text style={styles.textEn7}>b)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>vis die vóór de verzending wordt gedood en gekaakt;</Text>
                                <Text style={[styles.textIn7]}>/ Ikan yang disembelih dan disiangi sebelum diberangkatkan</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8 }]}>
                                <Text style={styles.textEn7}>c)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>aquacultuurdieren en producten daarvan die zonder verdere verwerking voor menselijke consumptie in de handel worden gebracht, mits zij zijn verpakt in detailverpakkingen die voldoen aan de bepalingen voor dergelijke verpakkingen in Verordening (EG) nr. 853/2004</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 10 }]}>/ Hewan budidaya dan produknya yang dipasarkan untuk konsumsi manusia tanpa proses pengolahan lebih lanjut, yang dikemas dalam kemasan eceran yang sesuai dengan persyaratan pengemasan yang tercantum pada Regulasi (EC) No. 853/2004</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8 }]}>
                                <Text style={styles.textEn7}>d)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>schaaldieren die bestemd zijn voor overeenkomstig artikel 4, lid 2, van Richtlijn 2006/88/EG erkende verwerkingsinrichtingen, of voor verzendingscentra, zuiveringscentra of soortgelijke bedrijven die beschikken over een systeem voor de behandeling van effluenten waarmee de desbetreffende pathogenen geïnaativeerd worden, of waar de effluenten andere behandelingen ondergaan, waardoor het risico vare overdracht van de ziekten naar de natuurlijke wateren tot een aanvaardbaar niveau wordt teruggebracht, </Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 10 }]}>Krustasea yang ditujukan untuk unit pengolahan ikan yang diotorisasi sesuai dengan pasal 4(2) dara Directive 2006/88/EC, atau sentra pengiriman, sentra purifikasi atau usaha sejenis yang dilengkapi dengan sistem perlakuan effluent untuk menonaktifkan bakteri pathogen yang dicurigai, atau dimana effluent diberi perlakuan lain untuk mereduksi risiko penularan penyakit ke perairan sampai batas yang dapat diterima.</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8 }]}>
                                <Text style={styles.textEn7}>e)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>schaaldieren die bestemd zijn voor verdere verwerking voor menselijke consumptie zonder tijdelijke opslag op de plaats van verwerking en die daartoe verpakt en geetiketteerd zijn overeenkomstig Verordening (EG) nr. 853/2004/</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 10 }]}>Krustasea yang ditujukan untuk proses pengolahan lanjutan sebelum dikonsumsi manusia tanpa melalui penyimpanan sementara di tempat proses dan dikemas dan diberi label untuk tujuan tersebut sesuai dengan Regulasi (EC) No 853/2004</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(3)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>De punten 11.2.1 en 11.2.2 van dit certificaat zijn alleen van toepassing op soorten die vatbaar zijn voor een of meer in de titel vermelde ziekten. Een lijst van vatbare soorten is opgenomen in bijlage IV bij Richtlijn 2006/88/EG/</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 8 }]}>Bagian II.2.1 dan 11.2.2 dari sertifikat ini hanya berlaku bagi jenis-jenis rentan terhadap satu atau lebih penyakit sesuai dengan judul dari butir yang sesuai. Jenis-jenis yang rentan terhadap penyakit tercantum pada Annex IV dari Directive 2006/88/EC</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(4)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>Doorhalen wat niet van toepassing is/</Text>
                                <Text style={[styles.textIn7]}>Disimpan bila sesuai.</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(5)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>Voor zendingen van voor EHN, Taura-syndroom en/of Yellow-head-ziekte, vathare soorten moet deze verklaring worden bewaard om de zending in enig deel van de Unie te mogen invoeren.</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 8 }]}>Untuk partai yang dikirim jenis-jenis yang rentan terhadap penyakit EHN. Taura syndrome, dan/atau Yellowhead, pernyataan ini harus disimpan untuk partai/lot yang akan dikirim ke setiap bagian dari UE</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(6)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>Om de zending te mogen invoeren in een lidstaat, gebied of compartiment (vakken 1.9 en 1.10 van deel 1 van het certificaat) die/dat vrij is verklaard van VHS, IHN, ISA, KHV of besmetting met het wittevlekkenvirus of waarvoor een overeenkomstig artikel 44, lid 1 of 2, van Richrlijn 2006/88/EG vastgesteld surveillance-of uitroeiingsprogramma geldt, moet een van deze verklaringen worden bewaard als de zending soorten bevat die vatbaar zijn voor de ziekte(n) waarvan het betrokken gebied vrij is verklaard of waarvoor een programma geldt. Gegevens over de ziektestatus van alle kwekerijen en alle kweekgebieden van weekdieren in de Unie zijn te vinden op het volgende webadres: http://ec.europa.eu/food/animal/liveanimals/aquaculture/index_en.htm/</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 8 }]}>Untuk dapat diotorisasi ke negara anggota UE, zona atau kompartemen (kotak no 1.9 dan 1.10 Bagian I sertifikat) yang telah dinyatakan bebas dari VHS, IHN, ISA, KHV, atau bintik putih (white spot) atau dengan program survailen atau melalui program pemberantasan yang ditetapkan sesuai dengan pasal 44(1) atau (2) dari Directive 2006/88/EC Data tentang status penyakit untuk setiap pembudidayaan dan area buchdaya moluska di UE dapat diakses pada http://ec.europa.eu/food/animal/liveanimals/aquaculture/index_en.htm</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableIdt, { borderTop: 1, borderLeft: 0, borderBottom: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "50%", border: 0 }]}>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Officiële inspecteur/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Pengawas Mutu</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Naam (in bookletters)/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Nama (dengan huruf besar): </Text>
                                    <Text style={[styles.text, { textAlign: "left" }]}>{dataHc !== null ? dataHc.nmPejabat : ''}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Datum/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Tanggal :</Text>
                                    <Text style={[styles.text, { textAlign: "left" }]}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Stempel/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Stempel :</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { width: "50%", border: 0, paddingTop: 20 }]}>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Hoedanigheid en titel/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Titel dan Jabatan:</Text>
                                    <Text style={[styles.text, { textAlign: "left" }]}>OFFICIAL INSPECTOR</Text>
                                </View>
                                <View style={[styles.tableCol, { borderBottom: 0 }]}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Handtekening/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Tanda tangan</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default DraftXF